import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '../core/Icon.jsx';
import { IconButton } from '../core/IconButton.jsx';

const OPTIONS = [
  { value: null, label: '关闭定时' },
  { value: 'episode', label: '播完本集' },
  { value: 15, label: '15 分钟后' },
  { value: 30, label: '30 分钟后' },
  { value: 60, label: '60 分钟后' },
];

function labelOf(value) {
  const hit = OPTIONS.find((o) => o.value === value);
  return hit ? hit.label : `${value} 分钟后`;
}

/** Sleep-timer (定时结束) button + pop menu. Active state shows orange bedtime glyph. */
export function TimerControl({ value = null, onChange, menuDirection = 'up', className = '' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  return (
    <span className={`bjl-popwrap ${className}`} ref={ref}>
      <IconButton
        icon="bedtime"
        label={value ? `定时结束 · ${labelOf(value)}` : '定时结束'}
        active={value != null || open}
        fill={value != null}
        onClick={() => setOpen(!open)}
      />
      {open ? (
        <span className={`bjl-popmenu bjl-popmenu--${menuDirection}`} role="menu">
          <span className="bjl-popmenu__label">定时结束</span>
          {OPTIONS.map((o) => (
            <button
              key={String(o.value)}
              className={`bjl-popmenu__item ${o.value === value ? 'is-active' : ''}`}
              onClick={() => { onChange && onChange(o.value); setOpen(false); }}
            >
              {o.label}
              {o.value === value ? <Icon name="check" /> : null}
            </button>
          ))}
        </span>
      ) : null}
    </span>
  );
}
